import {
  ONBOARDING_SENDING_EMAIL,
  ONBOARDING_TOUR_COMPLETED,
  ONBOARDING_UDPATE,
} from 'constants/actions';

export function setSendingDownloadEmail(sendingDownloadEmail) {
  return { type: ONBOARDING_SENDING_EMAIL, sendingDownloadEmail };
}

export function onboardingTourCompleted(tour) {
  return { type: ONBOARDING_TOUR_COMPLETED, tour };
}

export function onboardingUpdate(toursCompleted) {
  return { type: ONBOARDING_UDPATE, completed: toursCompleted };
}
